import StorageManager from "~/lib/helpers/StorageManager";
import { getContextId, setContextId, readContextIdFromResponse, ensureContextId } from "~/lib/helpers/ContextId";

export default class BaseSalesforceService {
  private baseUrl: string;
  private headers: HeadersInit;

  constructor() {
    this.baseUrl =
      typeof window === "undefined"
        ? process.env.REMIX_API_HOST_SF_SERVER || "https://officehub.my.salesforce-sites.com/api/services/apexrest/v1"
        : "https://officehub.my.salesforce-sites.com/api/services/apexrest/v1";
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    const token = StorageManager.get("token");
    if (token) {
      this.headers["Authorization"] = token;
    }
  }


  private async handleResponse(response: Response) {
    const ctxId = readContextIdFromResponse(response);
    if (ctxId) setContextId(ctxId);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      // Only log errors in development
      if (typeof window === "undefined" || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        console.error("FROM BaseSalesforceService");
        console.error("OH-ERROR", JSON.stringify(errorData, null, 2));
      }
      throw new Error(response.statusText);
    }
    return response.json();
  }

  async apiGet(path: string) {
    const headers: HeadersInit = { ...this.headers };
    const ctx = ensureContextId();
    if (ctx) headers["X-Context-Id"] = ctx;
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: "GET",
      headers,
    });
    return this.handleResponse(response);
  }

  async apiPost(path: string, data?: any) {
    const headers: HeadersInit = { "Content-Type": "application/json" };
    const ctx = ensureContextId();
    if (ctx) headers["X-Context-Id"] = ctx;
    const response = await fetch(`${this.baseUrl}${path}`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    return this.handleResponse(response);
  }
}
